import { OrderAnalyticsApiClient } from '@fourthwall/services/dist/OrderAnalyticsApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useOfferOrdersByVariantsAnalyticsQuery = createQueryHook(
  OrderAnalyticsApiClient.getOfferOrdersByVariantsAnalytics,
  {
    queryKey: ['offerOrdersByVariantsAnalytics'],
  },
)
